import React from "react";
import Select from "react-select";
import "./SelectDropdown.css";

const customStyles = (width) => ({
  control: (provided, state) => ({
    ...provided,
    borderRadius: "5px",
    width: width,
    cursor: "Pointer",
    // height: "40px",
    fontWeight: 700,
    fontFamily: "Poppins",
    fontSize: 14,
    borderColor: state.isFocused ? "#9696A0" : "#CFD4D9",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(68, 4, 191, 0.2)" : null,
    "&:hover": {
      borderColor: state.isFocused ? "#9696A0" : "#CFD4D9",
    },
    transition: "background-color 0.2s, color 0.2s",
  }),

  menu: (provided, state) => ({
    ...provided,

    marginTop: 0,
  }),

  option: (provided, state) => ({
    ...provided,
    cursor: "Pointer",
    fontFamily: "Poppins",
    fontSize: 14,
    overflowX: "hidden",
    fontWeight: 500,
    backgroundColor: state.isSelected
      ? "#310489"
      : state.isFocused
      ? "#F5F6F7"
      : "#FFF",

    color: state.isSelected ? "#FFF" : state.isFocused ? "#310489" : "#323232",
    padding: "8px 20px",
  }),

  placeholder: (provided) => ({
    ...provided,

    color: "#9696A0",
    fontWeight: 700,
    fontFamily: "Poppins",
    fontSize: 14,
  }),

  indicatorSeparator: () => ({ display: "none" }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    transition: "transform 0.3s ease", // Add transition for smooth rotation

    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate based on dropdown state
  }),
});

const SelectDropdown = ({
  options,
  label,
  onChange,
  value,
  placeholder = "Select",
  isSearchable,
  children,
  isDisabled,
  classSelect = "select-dropdown",
  classDrop = "dropdown",
  width,
  isMulti,
}) => {
  return (
    <div className={classSelect}>
      <div className={classDrop}>
        <Select
          options={options}
          isSearchable={isSearchable}
          onChange={onChange}
          value={value}
          styles={customStyles(width)}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isMulti={isMulti}
        />

        {children}
      </div>
    </div>
  );
};

export default SelectDropdown;
